import { render, staticRenderFns } from "./roleMangent.vue?vue&type=template&id=3a7754fc&scoped=true"
import script from "./roleMangent.vue?vue&type=script&lang=js"
export * from "./roleMangent.vue?vue&type=script&lang=js"
import style0 from "./roleMangent.vue?vue&type=style&index=0&id=3a7754fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7754fc",
  null
  
)

component.options.__file = "roleMangent.vue"
export default component.exports